'use client';

import type { SchoolYearKey } from '@ocode/domain';
import { useEffect, useMemo } from 'react';
import useSWR from 'swr';
import { useApi } from '../provider/useApi';

/**
 * 학년별로 선택 가능한 교과서 목록
 * @example
 * const { data } = useDtbSelectableSubjectByYear()
 *
 * if( data ) {
 *    const yearKey = 'A01'
 *    console.log( data[yearKey] ) // ex) ['MATH', 'PHYSICS']
 * }
 */
export function useDtbSelectableSubjectByYear(): Record<SchoolYearKey, string[]> | undefined {
  const api = useApi();

  const { data, isLoading, error } = useSWR('/p/api/dtb/publ-year-and-subject-pairs', () =>
    api.dtb.getYearAndSubjectKeyPairs({}),
  );

  const availableData = useMemo<Record<SchoolYearKey, string[]> | undefined>(
    () =>
      data
        ? data.yearAndSubjects.reduce(
            (acc, cur) => {
              const arr = acc[cur.yearKey] ?? [];
              arr.push(cur.subjectKey);
              acc[cur.yearKey] = arr;
              return acc;
            },
            {} as Record<SchoolYearKey, string[]>,
          )
        : undefined,
    [data],
  );

  useEffect(() => {
    if (error) {
      console.warn('useDtbSelectableSubjectByYear() errror:', error);
    }
  }, [error]);

  return availableData;
}
